export class InvalidSessionError extends Error {
  constructor(
    public readonly sessionId: string,
    public readonly status: number,
    message?: string,
  ) {
    super(`Invalid session identifier "${sessionId}" for punchout authentication. Status code: ${status}. ${message ?? ''}`);
    this.name = 'InvalidSessionError';
  }
}
